<template lang="pug">
	modal
		.card.text-left
			.card-header
				| Editor de registros
				button.close(@click="cerrar") &times;
			.card-body.bg-light
				.form-group
					label
						b Tipo de jornada
					select.form-control.form-control-lg(v-model="registro.Naturaleza")
						option(:value="null") Selecciona
						option(value="Trabajo") Trabajo
						option(value="Libre") Libre
						option(value="Falta") Falta justificada
			.card-body(v-if="registro.Naturaleza === 'Libre'", style="background-color: #d2f2d4;")
				span.fa.fa-info-circle.mr-2(style="font-size:2em;vertical-align:middle;")
				| Vas a registrar una jornada de libranza. Debes tener en cuenta que la unidad mínima son las horas, por lo que no podrás registrar intérvalos que no sean horas exactas
			.card-body(v-else-if="registro.Naturaleza === 'Trabajo'", style="background-color: #ead3d3;")
				span.fa.fa-info-circle.mr-2(style="font-size:2em;vertical-align:middle;")
				| Vas a registrar una jornada laboral. Debes introducir la hora de entrada y la de salida más exactas posible.
			.card-body(v-else-if="registro.Naturaleza === 'Falta'", style="background-color: #d3abab;")
				span.fa.fa-info-circle.mr-2(style="font-size:2em;vertical-align:middle;")
				| Vas a registrar una falta justificada. Estas solo son válidas dentro de la jornada de trabajo habitual. En caso de tener un justificante adjúntalo
			.card-body(v-if="registro.Naturaleza")
				.row
					.col-xs-12.col-sm-12.col-md-6.col-lg-6.col-xl-6
						.form-group
							label
								span.fa.fa-sign-in.mr-2
								b Entrada
							.input-group
								.input-group-prepend
									.input-group-text
										span.fa.fa-calendar
								input.form-control(type="date" v-model="registro.FechaEntrada")
								.input-group-append
									.input-group-text
										span.fa.fa-clock-o
								input.form-control(type="time" v-mask="'##:##'" v-model="registro.HoraEntrada")
					.col-xs-12.col-sm-12.col-md-6.col-lg-6.col-xl-6
						.form-group
							label
								span.fa.fa-sign-out.mr-2
								b Salida
							.input-group
								.input-group-prepend
									.input-group-text
										span.fa.fa-calendar
								input.form-control(type="date", v-model="registro.FechaSalida")
								.input-group-append.input-group-prepend
									.input-group-text
										span.fa.fa-clock-o
								input.form-control(type="time" v-mask="'##:##'" v-model="registro.HoraSalida")
				.form-group
					label
						b Comentarios
					textarea.form-control(v-model="registro.Comentarios", placeholder="Opcional")
			.card-body.bg-light(v-if="registro.Naturaleza === 'Falta'")
				.row
					.col-xs-12.col-sm-12.col-md-6.col-lg-6.col-xl-6
						b Justificantes
						br
						button.btn.btn-primary.mt-2(@click="adjuntar()")
							span.fa.fa-file-o.mr-2
							| Adjuntar justificante
					.col-xs-12.col-sm-12.col-md-6.col-lg-6.col-xl-6
						.input-group.input-group-sm.mb-2(
							v-for="f in ficheros"
							:key="f.name"
						)
							.input-group-prepend
								.input-group-text.bg-dark.text-white
									span.fa.fa-file-o
							input.form-control(disabled="true", :value="f.name")
							.input-group-append
								button.btn.btn-sm.btn-danger(@click="quitaFichero(f)")
									span.fa.fa-trash
			.card-footer(v-if="registro.Naturaleza")
				.row
					.col.text-left
						button.btn.btn-sm.btn-primary(@click="guardar")
							span.fa.fa-save.mr-2
							| Guardar
					.col.text-right
						button.btn.btn-sm.btn-danger(@click="eliminar" v-if="registro.RegistroID")
							span.fa.fa-trash.mr-2
							| Eliminar
</template>

<script>
import axios from 'axios'
import { mapGetters } from 'vuex'
export default {
	props: ['RegistroID'],
	data () {
		return {
			registro: {
				RegistroID: null,
				FechaEntrada: null,
				HoraEntrada: null,
				FechaSalida: null,
				HoraSalida: null,
				Comentarios: null,
				Naturaleza: null,
				Latitud: null,
				Longitud: null,
				UsuarioID: null,
				ficheros: []
			},
			ficheros: []
		}
	},
	created () {
		if (this.RegistroID) {
			this.registro.RegistroID = this.RegistroID
			this.getRegistro()
		}
		if (!navigator.geolocation) {
			this.$error('Error', 'Debes fichar en un navegador que soporte geolocalización')
			this.cerrar()
		} else {
			this.registro.UsuarioID = this.usuario.ID
			navigator.geolocation.getCurrentPosition((data) => {
				this.registro.Latitud = data.coords.latitude
				this.registro.Longitud = data.coords.longitude
			}, () => {
				// this.$error('Error', 'Es necesaria la geolocalización para efectuar el fichaje')
				// this.cerrar()
				this.$store.commit('toast/danger', {
					titulo: 'Geolocalización no disponible',
					mensaje: 'No es posible geolocalizar este dispositivo.'
				})
			})
		}
	},
	computed: {
		...mapGetters({
			usuario: 'session/usuario'
		})
	},
	methods: {
		getRegistro () {
			axios.get('gestion-jornada/php/api/getRegistro.php?RegistroID=' + this.RegistroID)
				.then(res => {
					this.registro.RegistroID = this.RegistroID
					this.registro.FechaEntrada = res.data.FechaEntrada
					this.registro.HoraEntrada = res.data.HoraEntrada
					this.registro.FechaSalida = res.data.FechaSalida
					this.registro.HoraSalida = res.data.HoraSalida
					this.registro.Comentarios = res.data.Comentarios
					this.registro.Naturaleza = res.data.Naturaleza
					this.registro.UsuarioID = res.data.UsuarioID
				})
				.catch(e => {
					this.$error('Error', e.response.data.error)
				})
		},
		adjuntar () {
			const inp = document.createElement('input')
			inp.type = 'file'
			inp.multiple = true
			inp.addEventListener('change', async () => {
				for (let i = 0; i < inp.files.length; i++) {
					this.ficheros.push(inp.files[i])
				}
				document.body.removeChild(inp)
			})
			inp.style.display = 'none'
			document.body.appendChild(inp)
			inp.click()
		},
		async toBase64 (file) {
			return new Promise((resolve, reject) => {
				const reader = new FileReader()
				reader.readAsDataURL(file)
				reader.onload = () => resolve(reader.result)
				reader.onerror = error => reject(error)
			})
		},
		quitaFichero (f) {
			this.ficheros = this.ficheros.filter(fichero => fichero.name !== f.name)
		},
		guardar () {
			const expHora = /^\d{2}:\d{2}$/
			if (!this.registro.FechaEntrada) {
				this.$error('Error', 'Debes definir el día de entrada')
				return
			}

			if (!expHora.test(this.registro.HoraEntrada)) {
				this.$error('Error', 'Debes definir una hora de entrada correcta')
				return
			}

			if (!this.registro.FechaSalida) {
				this.$error('Error', 'Debes definir el día de salida')
				return
			}

			if (!expHora.test(this.registro.HoraSalida)) {
				this.$error('Error', 'Debes definir una hora de salida correcta')
				return
			}

			const fechaEntrada = this.registro.FechaEntrada + ' ' + this.registro.HoraEntrada
			const fechaSalida = this.registro.FechaSalida + ' ' + this.registro.HoraSalida

			if (this.registro.Naturaleza === 'Libre') {
				const expHora = /^\d{2}:00$/
				if (!expHora.test(this.registro.HoraEntrada)) {
					this.$error('Error', 'La hora de entrada y salida debe en punto')
					return
				}

				if (!expHora.test(this.registro.HoraSalida)) {
					this.$error('Error', 'La hora de entrada y salida debe en punto')
					return
				}
			}

			const form = {
				RegistroID: this.registro.RegistroID,
				FechaEntrada: fechaEntrada,
				FechaSalida: fechaSalida,
				Comentarios: this.registro.Comentarios,
				Naturaleza: this.registro.Naturaleza,
				UsuarioID: this.registro.UsuarioID
			}

			this.procesarFicheros(ficheros => {
				form.ficheros = ficheros
				axios.post('gestion-jornada/php/api/editar.php', form)
					.then(res => {
						this.$store.commit('toast/success', {
							titulo: 'Guardado'
						})
						this.cerrar()
					})
					.catch(e => {
						this.$error('Error', e.response.data.error)
					})
			})
		},
		procesarFicheros (cb) {
			const f = []
			let i = 0
			const procesar = () => {
				if (i >= this.ficheros.length) {
					cb(f)
					return
				}
				let fichero = this.ficheros[i]
				i++
				this.toBase64(fichero)
					.then(b => {
						f.push({
							Nombre: fichero.name,
							Tamano: fichero.size,
							Contenido: b
						})
						procesar()
					})
					.catch(e => {
						this.$error('Error', 'Error procesando el fichero: ' + fichero.name)
						procesar()
					})
			}
			procesar()
		},
		eliminar () {
			this.$store.commit('alertas/confirm', {
				titulo: 'Eliminar registro',
				mensaje: '¿Quieres eliminar este registro?',
				callback: acepta => {
					if (acepta) {
						axios.post('gestion-jornada/php/api/delRegistro.php', {RegistroID: this.registro.RegistroID})
							.then(res => {
								this.$store.commit('toast/success', {
									titulo: 'Registro eliminado'
								})
								this.cerrar()
							})
							.catch(this.$responseError)
					}
				}
			})
		},
		cerrar () {
			this.$emit('cerrar')
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/modulos/gestion-jornada/vue/components/editor/editor.vue